import { render } from "./UploadLocalVolume.vue?vue&type=template&id=74af27b5&scoped=true"
import script from "./UploadLocalVolume.vue?vue&type=script&lang=js"
export * from "./UploadLocalVolume.vue?vue&type=script&lang=js"

import "./UploadLocalVolume.vue?vue&type=style&index=0&id=74af27b5&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74af27b5"]])

export default __exports__